<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Add a New Vertical</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Vertical:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="vertical"
                v-model="verticals.vertical"
                v-validate="'required'"
                data-vv-as="Vertical"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('vertical')"
              >{{ errors.first("vertical") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Vertical Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="vertical_description"
                v-model="verticals.vertical_description"
                v-validate="'required'"
                data-vv-as="Vertical Description"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('vertical_description')"
              >{{ errors.first("vertical_description") }}</span
            >
          </div>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Submit</vs-button
              >
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from '@/config/abilities'
import moduleVerticalManagement from "@/store/vertical-management/moduleVerticalManagement.js";
import vSelect from "vue-select";
export default {
  data() {
    return {
                              abilities : null,

      verticals : {
              vertical:null,
              vertical_description : null
              }
      }
      
  },
  components: {
    "v-select": vSelect,
    moduleVerticalManagement,
  },
  created() {
     var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });   
    if (!moduleVerticalManagement.isRegistered) {
      this.$store.registerModule(
        "verticalsManagement",
        moduleVerticalManagement
      );
      moduleVerticalManagement.isRegistered = true;
    }
  },
  mounted() {
  },
  methods: {
    goBack: function() {
      this.$router.go(-1);
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if(result){
          this.addVerticals()
        }
      });
    },
    addVerticals() {
      this.$store
        .dispatch("verticalsManagement/addVertical",this.verticals)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Vertical Exists",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Vertical Added",
              text: "The vertical was added successfully"
            });
            this.$router.push({ path: "/verticals" });
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
</style>
